export enum StorkModules {
    KANBAN = 'kanban',
    TABLE_VIEW = 'table_view',
    MAP_VIEW = 'map_view',
    // APP_SETTINGS = 'app_settings', // Configuraciones DEPRECATED
    VEHICLES = 'vehicles',
    SEMITRAILERS = 'semitrailers',
    DRIVERS = 'drivers',
    CARRIERS = 'carriers',
    ACCOUNTS = 'accounts',
    LOCATIONS = 'locations',
    ZONES = 'zones',
    ALERTS_EVENTS = 'alerts_events',
    REPORTS = 'reports',
    CHAT = 'chat',
    // Configuration App Modules
    TAGS = 'config_tags',
    WEBHOOKS = 'config_webhooks',
    API_KEYS = 'config_api_keys',
    NOTIFICATIONS = 'config_notifications',
    PROFILE = 'config_profile',
    USERS = 'config_users',
    GENERAL_SETTINGS = 'config_general_settings',
    DRIVER_APP = 'config_driver_app',
    EVENTS = 'config_events',
    OPERATIVE_STANDARDS = 'config_operative_standards',
    SERVICE_TYPES = 'config_service_types',
    PRODUCTS = 'config_products',
}
